<template>
  <div>
    <h1 class="font-bold my-10">
      {{ $t('nav.privacy') }}
    </h1>
    <div class="privacy-policy mb-40" v-html="privacyPolicy"></div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'privacy',
  data() {
    return {
      privacyPolicy: '',
    };
  },
  methods: {
    async getPrivacyPolicy() {
      try {
        const response = await api.get('info/');
        this.privacyPolicy = response.data['privacy_policy'] || '';
      } catch (e) {
        console.log(e);
      }
    },
  },
  async created() {
    await this.getPrivacyPolicy();
  },
};
</script>


<style scoped>
.privacy-policy {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.privacy-policy :deep(*) {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.privacy-policy :deep(pre) {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-family: inherit;
}

.privacy-policy :deep(img) {
  height: auto;
}

.privacy-policy :deep(table) {
  display: block;
  overflow-x: auto;
}
</style>
